import React from "react";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Breadcrumb";

const AboutScreen = () => {
  const info = useSelector((state) => state.store)?.store?.staticInfo?.[0];

  return (
    <div>
      <Breadcrumb heading={"About"} />
      <div className="container mx-auto py-20">
        <div className="flex items-center justify-center">
          <img src="/title-image.png" className="mb-4" alt="Flowers" />
        </div>
        <h2 className="heading_h2 text-center mb-10 mt-2">
          {info ? "About the company" : ""}
        </h2>
        <p className="my-4 p-4">
          <img
            src={info ? info?.aboutImage : "/pro-1.png"}
            className="pr-10 float-left"
            alt="About"
            width={600}
          />
          {info?.about ? (
            <div
              dangerouslySetInnerHTML={{
                __html: info?.about,
              }}
            />
          ) : (
            `Lorem Ipsum is simply dummy text of the printing
             and typesetting industry. Lorem Ipsum has been the industry's 
             standard dummy text ever since the 1500s, when an unknown printer 
             took a galley of type and scrambled it to make a type specimen book. 
             It has survived not only five centuries, but also the leap into electronic 
             typesetting, remaining essentially unchanged. It was popularised in the 1960s 
             with the release of Letraset sheets containing Lorem Ipsum passages, and more 
             recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum
             
             is simply dummy text of the printing
             and typesetting industry. Lorem Ipsum has been the industry's 
             standard dummy text ever since the 1500s, when an unknown printer 
             took a galley of type and scrambled it to make a type specimen book. 
             It has survived not only five centuries, but also the leap into electronic 
             typesetting, remaining essentially unchanged. It was popularised in the 1960s 
             with the release of Letraset sheets containing Lorem Ipsum passages, and more 
             recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`
          )}
        </p>
      </div>
    </div>
  );
};

export default AboutScreen;
